import React from 'react';
import PropTypes from 'prop-types';
import Modal from './index';
import { connect } from 'react-redux';
import { toggleMoreModal } from './actions';
import {translate} from "react-i18next";

@translate(['modal'], {wait: true})
class MoreModal extends Modal {
  constructor(props) {
    super(props);

    this.toggleModal = this.toggleModal.bind(this);
  }

  toggleModal(e) {
    e.preventDefault();
    this.props.toggleModal();
  }

  render() {
    const {t} = this.props;

    return (
      <div id="popupSupport" className="popapWrapper popapDefaultWrapper active">
        <div ref="modal" className="popup">
          <a href="#close" onClick={this.toggleModal}  className="popup__close"/>
          <div className="popup__aside">
            <h2>{t('modal:help')}</h2>
            <ul className="supportNav">
              <li className="active"><a href="" onClick={e => e.preventDefault()}>{t('modal:support')}</a></li>
            </ul>
          </div>
          <div className="popup__content">
            <h2>{t('modal:support')}</h2>
            <div className="popupSupport__contactWrapper">
              <div className="popupSupport__contactItem">
                <div className="title">{t('modal:tech_support')}</div>
                <div className="holder">
                  <div className="date">{t('modal:all_day')}</div>
                  <div className="tel">8 800 555 42 99</div>
                  <div className="mail"><a href="mailto:support@smartdriving.io">support@smartdriving.io</a></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <a onClick={this.toggleModal} href="#close" className="overlay"/>
      </div>
    );
  }
}

MoreModal.propTypes = {
  toggleModal: PropTypes.func,
};

export default connect(
  () => ({}),
  (dispatch) => {
    return {
      toggleModal() {
        return dispatch(toggleMoreModal());
      },
    };
  },
)(MoreModal);



// WEBPACK FOOTER //
// ./src/components/Modal/MoreModal.js